"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    titleIcon: {
        marginRight: theme.spacing(),
        fontSize: 48
    },
    smallTitleIcon: {
        marginRight: theme.spacing()
    },
    button: {
        paddingTop: theme.spacing() + 4,
        paddingBottom: theme.spacing() + 4
    },
    centered: {
        display: 'flex',
        alignItems: 'center'
    },
    leftIcon: {
        marginRight: theme.spacing()
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    disableBackground: {
        color: theme.palette.text.disabled,
        backgroundColor: theme.palette.action.disabledBackground,
        borderColor: theme.palette.text.disabled.getLowEmphasis(),
        pointerEvents: 'none'
    }
});
exports.default = styles;
//# sourceMappingURL=TitleStyle.js.map